import React, { useCallback, useContext } from 'react';
import { Pressable, View } from 'react-native';
import { Text, withTheme } from '@rneui/themed';
import { CollectionItemType, } from '@annunciate/core';
import { useCollectionItemAppearsInQuery } from '@annunciate/query';
import { NavigationContext } from '../../providers';
export const InnerAppearsIn = ({ type, id, demarcationCharacter = '•', containerStyle, buttonContainerStyle, buttonTextStyle, buttonDemarcatorTextStyle, }) => {
    const { data } = useCollectionItemAppearsInQuery({
        id,
        type,
    });
    const { onNavigateToItem } = useContext(NavigationContext);
    const onPress = useCallback((collection) => {
        if (collection &&
            collection.id &&
            collection.__typename &&
            onNavigateToItem) {
            onNavigateToItem(collection);
        }
    }, [onNavigateToItem]);
    const appearsIn = data?.appearsIn || [];
    if (appearsIn.length <= 0) {
        return null;
    }
    else {
        return (React.createElement(View, { style: containerStyle }, appearsIn.map((item, idx) => (React.createElement(React.Fragment, { key: item.id },
            React.createElement(Pressable, { key: item.id, onPress: () => onPress(item.parent), style: buttonContainerStyle },
                React.createElement(Text, { style: buttonTextStyle }, item.parent.name)),
            appearsIn.length > 1 && idx != appearsIn.length - 1 && (React.createElement(Text, { style: buttonDemarcatorTextStyle }, demarcationCharacter)))))));
    }
};
export const UnthemedAppearsIn = ({ item, ...props }) => {
    const type = item?.__typename === 'Content'
        ? CollectionItemType.Content
        : CollectionItemType.Collection;
    if (!type || !item?.id) {
        return null;
    }
    return (React.createElement(InnerAppearsIn, { type: type, id: item.id, ...props }));
};
export const AppearsIn = withTheme(UnthemedAppearsIn, 'AppearsIn');
//# sourceMappingURL=AppearsIn.js.map